import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "System Settings")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "col-sm-6 text-right"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus-square" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No settings found!", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "table table-fixed"
}
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "col-md-5" }
const _hoisted_13 = ["value", "onChange"]
const _hoisted_14 = ["value", "onChange"]
const _hoisted_15 = { class: "text-secondary" }
const _hoisted_16 = { class: "col-md-1 text-right" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]

import { computed, ref, inject, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { SystemProperty, Dictionary } from '@/models';
import TiptapEditor from '@/components/editor/TiptapEditor.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SystemSetting',
  setup(__props) {

const store = useStore();

const defaultproperties = [
  {
    propertykey: "current.app.version",
    prompt: "Curent app version",
    description: "Version number to be incremeneted everyime there is a new app release. This shows notification on all tablets and encourages the users to upgrade",
    propertytype: "number",
  },
  {
    propertykey: "app.release.notes",
    prompt: "Release notes",
    description: "Announcements and change logs for new feature as well as bug fixes. These notes gives the user an impression of what is changing it the app.",
    propertytype: "richtext",
  },
  {
    propertykey: "booking.email.fromaddress",
    prompt: "Booking confirmations from address",
    description: "Source email address to be used while sending various confirmations and notification email from booking form",
    propertytype: "text",
  },
  {
    propertykey: "booking.email.ccaddress",
    prompt: "Booking confirmations CC address",
    description: "CC email address to be used while sending various confirmations and notification email from booking form",
    propertytype: "text",
  },
  {
    propertykey: "booking.email.bccaddress",
    prompt: "Booking confirmations BCC address",
    description: "BCC email address to be used while sending various confirmations and notification email from booking form",
    propertytype: "text",
  },
  {
    propertykey: "dataentry.email",
    prompt: "Data entry email address",
    description: "Default email address for sending data entry related emails",
    propertytype: "text",
  },
];

const defaultpropertylist = computed(() => {
  return defaultproperties
    .filter((dp) => {
      const index = systemproperties.value?.findIndex(
        (sp: SystemProperty) => dp.propertykey === sp.propertykey
      );
      return index !== undefined && index < 0;
    })
    .map(SystemProperty.parse);
});

const systemproperties = computed(() => store.getters['dictionary/systemproperties']);
const currentsystemproperty = computed(() => store.getters['dictionary/currentsystemproperty']);
const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);

const setSystemPropertyValue = async (payload: {
    index: number;
    data: string;
  }) => {
    await store.dispatch('dictionary/setSystemPropertyValue', payload);
};

const customLabelForSystemProperty = (property: SystemProperty) => {
  return property.prompt;
};

const getPropertyDescription = (sp: SystemProperty) => {
  let description = '';
  const defaultproperty = defaultproperties.find((dp) => dp.propertykey === sp.propertykey);
  if (defaultproperty) {
    description = defaultproperty.description;
  }
  return description;
};

const addnewproperty = async () => {
  await store.dispatch('dictionary/addSystemProperty', new SystemProperty());
};

const remove = async (index: number) => {
  await store.dispatch('dictionary/removeSystemProperty', index);
};

const onSelectPropertyType = async (property: any) => {
  await store.dispatch('dictionary/setSystemPropertyKey', property);
};

const saveSystemPropertyValue = async (index: number, $event: any) => {
  await setSystemPropertyValue({
      index,
      data: $event.target.value,
    });
};


return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (defaultpropertylist.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "btn btn-lg btn-primary",
                onClick: addnewproperty
              }, [
                _hoisted_4,
                _createTextVNode(" New ")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (
        (!systemproperties.value || !systemproperties.value.length) && !hasBlockingRequests.value
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (_openBlock(), _createElementBlock("table", _hoisted_8, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(systemproperties.value, (systemproperty, $index) => {
              return (_openBlock(), _createElementBlock("tr", { key: $index }, [
                _createElementVNode("td", _hoisted_9, [
                  (systemproperty === currentsystemproperty.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_singleselect_text, {
                          modelValue: currentsystemproperty.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentsystemproperty).value = $event)),
                          options: defaultpropertylist.value,
                          "custom-label": customLabelForSystemProperty,
                          onSelect: onSelectPropertyType
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", null, _toDisplayString(systemproperty.prompt), 1)
                      ]))
                ]),
                _createElementVNode("td", _hoisted_12, [
                  (
                systemproperty.propertytype === '' ||
                systemproperty.propertytype === 'text'
              )
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        class: "form-control",
                        value: systemproperty.value,
                        onChange: ($event: any) => (saveSystemPropertyValue($index, $event))
                      }, null, 40, _hoisted_13))
                    : _createCommentVNode("", true),
                  (systemproperty.propertytype === 'number')
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "number",
                        class: "form-control",
                        value: systemproperty.value,
                        onChange: ($event: any) => (saveSystemPropertyValue($index, $event))
                      }, null, 40, _hoisted_14))
                    : _createCommentVNode("", true),
                  (systemproperty.propertytype === 'richtext')
                    ? (_openBlock(), _createBlock(TiptapEditor, {
                        key: systemproperty.propertykey,
                        content: systemproperty.value,
                        onBlur: ($event: any) => (setSystemPropertyValue({ index: $index, data: $event }))
                      }, null, 8, ["content", "onBlur"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(getPropertyDescription(systemproperty)), 1)
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger",
                    onClick: [
                      ($event: any) => (remove($index)),
                      _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    ]
                  }, _hoisted_19, 8, _hoisted_17)
                ])
              ]))
            }), 128))
          ])
        ]))
  ]))
}
}

})